"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.iExchange = exports.iSSO = exports.iCreateSSO = exports.iSSOClient = exports.iCreateSSOClient = void 0;
const t = require("io-ts");
exports.iCreateSSOClient = t.interface({
    name: t.string,
    clientDomain: t.string,
    clientId: t.string,
    clientSecret: t.union([t.string, t.null])
});
exports.iSSOClient = t.intersection([
    t.interface({
        id: t.number
    }),
    exports.iCreateSSOClient
]);
exports.iCreateSSO = t.interface({
    provider: t.string,
    name: t.string,
    visible: t.boolean,
    clientId: t.string,
    policy: t.keyof({
        'SINGLE': null,
        'MULTI': null
    })
});
exports.iSSO = t.intersection([
    t.interface({
        id: t.number,
        uuid: t.string,
        clientDomain: t.string
    }),
    t.partial({
        domains: t.array(t.string)
    }),
    exports.iCreateSSO
]);
exports.iExchange = t.interface({
    code: t.string,
    redirect_uri: t.string,
    state: t.string
});
//# sourceMappingURL=sso.js.map